import { useLeaderboardViewCreator } from '@viewCreators/leaderboard-view-creator';
import { LeaderView, ParticipantView } from '@views';
import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { ToDate } from '@app/utils/DateUtils';

export const useLeaderCardController = (groupId: number, groupStartDate: string | DateTime) => {
  const DAY_14 = 14;

  const message = 'You’re on your way! This feature unlocks as you advance through the program.';

  const EMPTY = {
    [0]: {
      participant: { id: 0, name: '', avatarUrl: '' } as unknown as ParticipantView,
      successfulWeeks: 0,
      currentStreak: 0,
    },
  } as LeaderView;

  const { data: leaders } = useLeaderboardViewCreator(groupId);

  const enabled = useMemo(() => {
    if (!leaders || !groupStartDate) return false;
    return Math.abs(ToDate(groupStartDate).diffNow('days').days) >= DAY_14;
  }, [leaders, groupStartDate]);

  return {
    leaders: leaders || EMPTY,
    enabled,
    disabledMessage: message,
  };
};
